import type { CheckboxSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

const CheckboxContainerUlStyled = styled.ul<{ $style: ElementStyleCss<CheckboxSchemaType> }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $style }) => $style.indents.gap};
  flex-grow: 1;
  list-style-type: none;
`

export default CheckboxContainerUlStyled
